import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { HistoryItem } from '../classes/history-item';
import { TranslateService } from '@ngx-translate/core';
import { HasSubscriptions } from '../components/has-subscriptions';
import { User } from '../classes/user';
import { Observable, of } from 'rxjs';

@Injectable()
export class RoutingHistoryService extends HasSubscriptions {
  private _user: User;
  private _lastHistoryItem?: HistoryItem;
  constructor(protected userService: UserService,
    private translate: TranslateService) {
    super();
    this.addSub(this.userService.currentUser.subscribe(user => {
      this._user = user;
    }));
  }

  get backToText(): Observable<string> {
    return this._lastHistoryItem && this._lastHistoryItem.translateValue ? this.translate.get(this._lastHistoryItem.translateValue) : of('');
  }

  get lastHistoryItem(): HistoryItem | null {
    return this._lastHistoryItem || null;
  }

  get returnUrl(): any | null {
    return this._lastHistoryItem ? this._lastHistoryItem.returnUrl : null;
  }

  get returnQueryParams() {
    return this._lastHistoryItem ? this._lastHistoryItem.returnQueryParams : null;
  }
  // this function should be used on next page's ngOnInit
  push(currentRoute: HistoryItem): void {
    // Set user's last history so we know where to send them back to.
    this._lastHistoryItem = this._user.session.history[this._user.session.history.length - 1];
    // Push to history if user is not navigating to a LDP
    // If navigating to LDP, need to check if previous route is also a LDP
    if (!this.isLDP(currentRoute.returnUrl[0])) {
      this._user.session.history.push(currentRoute);
    } else if (this._lastHistoryItem && !this.isLDP(this._lastHistoryItem.returnUrl[0])) {
      this._user.session.history.push(currentRoute);
    }
  }

  private isLDP(url: string) {
    return url.endsWith('-lst/');
  }

  pop() {
    // Remove the last 2 history items from the array since we are going back there now.
    // Last one is the current page which is no longer needed, 2nd last is the page we are going back to.
    this._user.session.history.pop();
    this._user.session.history.pop();
  }
}
